import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GET_EMPLOYEE_DROPDOWN_LIST,
  GET_REPORT_TASK,
} from "../../../components/utils";
import { getRequest } from "../../../components/axiosClient";
import { errorNotification } from "../../../components/toast-notification/common-toast";
import CustomDataGridTable from "../../../components/common/DataGridTable";
import Select from "react-select";
import LoadingSpinner from "../../../components/loader/LoadingSpinner";

const Repotemployeetask = () => {
  const [getAlltask, setgetAlltask] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const getReportAllEmployeetask = async () => {
    try {
      setLoading(true);
      let apiUrl = `${GET_REPORT_TASK}${selectedUser?.value ?  "?user_id="+selectedUser?.value:""}`;
      // let apiUrl = `${GET_REPORT_TOTAL_TASK}?start_date=${startDateView}&end_date=${endDateView}`;

      const res = await getRequest(apiUrl, null, navigate);

      if (res.data && res.data.data) {
        setgetAlltask(res.data.data);
      }

      //   if (res.data && res.data.data && Array.isArray(res.data.data.page_data)) {
      //     setListAllEmployee(res.data.data.page_data);
      //     setPageInformation(res.data.data.page_information);
      //   } else {
      //     errorNotification(res.errormessage);
      //     setListAllEmployee([]);
      //   }
      setLoading(false);
    } catch (error) {
      errorNotification(error);
      setLoading(false);
    }
  };
  const getUsersList = async () => {
    try {
      const url = `${GET_EMPLOYEE_DROPDOWN_LIST}`;
      const res = await getRequest(url, null, navigate);
      if (res.data && Array.isArray(res.data.data)) {
        const options = res.data.data.map((project) => ({
          label: `${project?.first_name} ${project?.last_name}`,
          value: project?.id,
        }));
        setUserList([...options]);
      } else {
        setUserList([]);
      }
    } catch (error) {
      errorNotification(error.message);
    }
  };

  useEffect(() => {
    getUsersList();
  }, []);

  useEffect(() => {
    getReportAllEmployeetask();
  }, [selectedUser]);




  console.log("getAlltask", getAlltask);
  const columns = [
    {
      field: "first_name",
      headerName: "First Name",
      width: 150,
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: 150,
    },
    {
      field: "role",
      headerName: "Role",
      width: 150,
    },
    {
      field: "projects",
      headerName: "Project Task Status",
      width: 800,
      renderCell: (params) => {
        if (!params.value || params.value.length === 0) {
          return "No Projects";
        }
        return (
          <TableContainer
            component={Paper}
            sx={{ boxShadow: "none", width: "100%", p: "8px 0px" }}
          >
            <Table size="small" sx={{ border: "1.2px solid #e0e0e0" }}>
              <TableHead>
                <TableRow
                // sx={{ backgroundColor: "#f5f5f5" }}
                >
                  <TableCell sx={{ padding: 0, textAlign: "center" }}>
                    <strong>Project Name</strong>
                  </TableCell>
                  <TableCell sx={{ padding: 0, textAlign: "center" }}>
                    <strong>To do</strong>
                  </TableCell>
                  <TableCell sx={{ padding: 0, textAlign: "center" }}>
                    <strong>In Progress</strong>
                  </TableCell>
                  <TableCell sx={{ padding: 0, textAlign: "center" }}>
                    <strong>To be Verified</strong>
                  </TableCell>
                  <TableCell sx={{ padding: 0, textAlign: "center" }}>
                    <strong>Completed</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {params.value.map((project) => (
                  <TableRow key={project.id}>
                    <TableCell sx={{ padding: 0, textAlign: "center" }}>
                      {project.name}
                    </TableCell>
                    <TableCell sx={{ padding: 0, textAlign: "center" }}>
                      {project.todo}
                    </TableCell>
                    <TableCell sx={{ padding: 0, textAlign: "center" }}>
                      {project.in_progress}
                    </TableCell>
                    <TableCell sx={{ padding: 0, textAlign: "center" }}>
                      {project.to_be_verified}
                    </TableCell>
                    <TableCell sx={{ padding: 0, textAlign: "center" }}>
                      {project.completed}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        );
      },
    },
  ];
  console.log("getAlltask", getAlltask);

  const rows = getAlltask?.map((data) => ({
    id: data.id,
    first_name: data.first_name,
    last_name: data.last_name,
    role: data?.role?.name,
    projects: data?.project_members?.map((projectMember) => ({
      id: projectMember.project.id,
      name: projectMember.project.name,
      todo:
        projectMember.project.task_statuses.find(
          (task) => task.title === "To do"
        )?.total_task || 0,
      in_progress:
        projectMember.project.task_statuses.find(
          (task) => task.title === "In Progress"
        )?.total_task || 0,
      to_be_verified:
        projectMember.project.task_statuses.find(
          (task) => task.title === "To be verified"
        )?.total_task || 0,
      completed:
        projectMember.project.task_statuses.find(
          (task) => task.title === "Completed"
        )?.total_task || 0,
    })),
  }));
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      height={"100%"}
      width={"100%"}
    >
      <Select
        placeholder="Select user"
        className="rounded-lg text-capitalize max-w-60 m-2"
        type="text"
        options={userList}
        name="assignee to"
        isClearable={true}
        value={userList.find((option) => option.value === selectedUser?.value)}
        onChange={(selectedOption) =>
          setSelectedUser(selectedOption)
        }
      />
      <Box flex={1} overflow={"auto"}>
        {loading ? (
                  <LoadingSpinner />
                ) : (
        <CustomDataGridTable
          columns={columns}
          rows={rows}
          hideFooter={true}
          unstable_strictMode={false}
          getRowHeight={() => "auto"}
          sx={{
            "& .MuiDataGrid-cell": {
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            },
          }}
        />
        )}
      </Box>
    </Box>
  );
};

export default Repotemployeetask;
